import formatToPoolInfo from './formatToPoolInfo';
import { GetXvsVaultPoolInfoInput, GetXvsVaultPoolInfoOutput } from './types';

export * from './types';

const getXvsVaultPoolInfo = async ({
  xvsVaultContract,
  rewardTokenAddress,
  poolIndex,
}: GetXvsVaultPoolInfoInput): Promise<GetXvsVaultPoolInfoOutput> => {
  const res = await xvsVaultContract.methods.poolInfos(rewardTokenAddress, poolIndex).call();
  return formatToPoolInfo(res);
};

export default getXvsVaultPoolInfo;
